export default "__VITE_ASSET__d72490b5__"